import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import DeclineQuotationModal from '../decline-quotation-modal/DeclineQuotationModal'
import OwnerCurrentActionFooterContainer from '../OwnerCurrentActionFooterContainer'
import { IProposalInteractionsProps } from '../../../../../../organisms/proposal/Proposal'
import PingPongButton from '../../../../../../organisms/proposal/proposal-cta/buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../../../../organisms/proposal/proposal-cta/utils/ping-pong-button-type.enum.ts'

const OwnerWaitingUserBookingConfirmationFooter = ({
  ownerActions,
}: {
  ownerActions: IProposalInteractionsProps['ownerActions']
}) => {
  const [isOpenDeclineQuotationModal, setIsOpenDeclineQuotationModal] =
    useState(false)

  const ownerDeclinedQuotation = ownerActions?.ownerDeclinedQuotation

  if (!ownerDeclinedQuotation) {
    return null
  }

  return (
    <OwnerCurrentActionFooterContainer>
      <PingPongButton
        dataTestId='waiting-user-booking-confirmation-button'
        label={
          <FormattedMessage
            id='ui.ownerCurrentAction.OwnerWaitingUserBookingConfirmationFooter.button.waiting.label'
            defaultMessage='Attente de confirmation du client'
          />
        }
        type={PingPongButtonTypeEnum.WAITING}
      />
      <PingPongButton
        label={
          <FormattedMessage
            id='ui.ownerCurrentAction.OwnerWaitingUserBookingConfirmationFooter.button.notAvailable.label'
            defaultMessage="Le lieu n'est plus disponible"
          />
        }
        type={PingPongButtonTypeEnum.DECLINED_BY_OWNER}
        onClick={() => setIsOpenDeclineQuotationModal(true)}
      />
      {isOpenDeclineQuotationModal && (
        <DeclineQuotationModal
          isOpenModal={isOpenDeclineQuotationModal}
          setIsOpenModal={setIsOpenDeclineQuotationModal}
          ownerDeclinedQuotation={ownerDeclinedQuotation}
        />
      )}
    </OwnerCurrentActionFooterContainer>
  )
}

export default OwnerWaitingUserBookingConfirmationFooter
